import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { RouteTypes } from './constants';
import PrivateRoute from './components/PrivateRoute';

import NotFoundPage from '../pages/NotFound';
import AuthenticationPage from '../pages/Authentication';
import Dashboard from '~/pages/Dairy/Dashboard';
import PublicRoute from './components/PublicRoute';
import InnerContent from '../components/InnerContent';
import DairyFactory from '~/pages/Dairy/DairyFactory';
import Settings from '../pages/Dairy/Settings';
import TradingSlot from '../pages/Dairy/Settings/TradingSlot';
import Farmers from '../pages/Dairy/DairyFactory/Farmers';
import CreateEditFarmers from '../pages/Dairy/DairyFactory/Farmers/CreateEditFarmers';
import ShowFarmer from '~/pages/Dairy/DairyFactory/Farmers/ShowFarmer';
import FarmerUsers from '../pages/Dairy/DairyFactory/FarmerUsers';
import FarmerGroups from '../pages/Dairy/DairyFactory/DairyFactoryProfile/FarmerGroups';
import ShowFarmerGroup from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/FarmerGroups/ShowFarmerGroup';
import PriceCalculator from '../pages/Dairy/DairyFactory/DairyFactoryProfile/PriceCalculator';
import MilkPayment from '../pages/Dairy/DairyFactory/DairyFactoryProfile/MilkPayment';
import ActivityLogs from '../pages/Dairy/DairyFactory/ActivityLogs';
import DairyFactoryProfile from '../pages/Dairy/DairyFactory/DairyFactoryProfile';
import DairyFactoryProfileBanks from '../pages/Dairy/DairyFactory/DairyFactoryProfile/Banks';
import DairyFactoryProfileLocations from '../pages/Dairy/DairyFactory/DairyFactoryProfile/Locations';
import DairyFactoryProfileUsers from '../pages/Dairy/DairyFactory/DairyFactoryProfile/Users';
import CreateEditBanks from '@src/pages/Dairy/DairyFactory/DairyFactoryProfile/Banks/CreateEditBanks';
import MilkFixedPrice from '@src/pages/Dairy/MilkFixedPrice';
import ShowMilkFixedPrice from '~/pages/Dairy/MilkFixedPrice/ShowMilkFixedPrice';
import Show from '~/pages/Farmer/MilkFixedPrice/Show';
import ResultsFarmer from '~/pages/Farmer/MilkFixedPrice/Results'
import CreateEditMilkFixedPrice from '~/pages/Dairy/MilkFixedPrice/CreateEditMilkFixedPrice';
import OffersPreviewMilkFixedPrice from '~/pages/Dairy/MilkFixedPrice/OffersPreviewMilkFixedPrice';
import Results from '~/pages/Dairy/MilkFixedPrice/Results';
import OfferAmount from '~/pages/Farmer/MilkFixedPrice/OfferAmount';
import Profile from '~/pages/Profile';
import Survey from '@src/pages/Dairy/Survey';
import Faq from '@src/pages/Dairy/Faq';
import CreateEditFaq from '~/pages/Dairy/Faq/CreateEditFaq';
import FaqBuilder from '~/pages/Dairy/Settings/FAQ';
import Newsletter from '@src/pages/Dairy/Newsletter';
import CreateEditUser from '~/pages/Users/User/Edit';
import CreateFarmerUser from '~/pages/Dairy/DairyFactory/FarmerUsers/CreateFarmerUser';
import SetPassword from '~/pages/SetPassword';
import ProfileSettings from '~/pages/ProfileSettings';
import Security from '~/pages/Dairy/Settings/Security/Index';
import PasswordForm from '~/pages/Authentication/PaswordForm';
import FarmerMilkFixedPrice from '~/pages/Farmer/MilkFixedPrice';
import { useAuth } from './components/AuthProvider';
import DashboardFarmer from '~/pages/Farmer/Dashboard'
import CreateEditNewsletter from '~/pages/Dairy/Newsletter/CreateEditNewsletter';
import ShowNewsletterDairy from '~/pages/Dairy/Newsletter/ShowNewsletterDairy';
import NewsletterFarmer from '~/pages/Farmer/Newsletter';
import NewsLetterPreviewFarmer from '~/pages/Farmer/Newsletter/ShowNewsletterFarmer';
import General from '~/pages/Dairy/Settings/General';
import Messaging from '~/pages/Dairy/Settings/Messaging';
import History from '~/pages/Dairy/DairyFactory/ActivityLogs/History';
import FarmerProfile from '~/pages/Farmer/FarmerProfile';
import ShowUser from '~/pages/Users/User/Show'
import ReportTradingActivities from '~/pages/Farmer/Reporting/TradingActivities'
import ReportFixedPrice from '~/pages/Farmer/Reporting/FixedPrice'
import FutureContracts from '~/pages/Dairy/FutureContracts';
import FutureContractsChart from '~/pages/Dairy/FutureContracts/FutureContractsChart';
import DairyTradingActivities from '~/pages/Dairy/Reporting/TradingActivities'
import ForceChangePassForm from '~/pages/Authentication/ForceChangePassForm';
import DairyFixedPrice from '~/pages/Dairy/Reporting/FixedPrice'
import CloudStorage from '~/pages/Dairy/CloudStorage';
import SettingsCloudStorage from '~/pages/Dairy/Settings/CloudStorage'
import FTP from '~/pages/Dairy/Settings/FTP';
import FTPLogs from '~/pages/Dairy/Settings/FTPLogs';
import MgaAttachment from '~/pages/Dairy/DairyFactory/Farmers/MgaAttachment';
import CreateMgaAttachment from '~/pages/Dairy/DairyFactory/Farmers/MgaAttachment/CreateMgaAttachment';
import LoginPopup from '~/pages/Dairy/Settings/LoginPopup';
import CreateEditLoginPopup from '~/pages/Dairy/Settings/LoginPopup/CreateEditLoginPopup';
import CreateEditSurvey from '~/pages/Dairy/Survey/CreateEditSurvey';
import ShowSurvey from '~/pages/Dairy/Survey/ShowSurvey';
import CreateEditQuestion from '~/pages/Dairy/Survey/ShowSurvey/CreateEditQuestion';
import ShowQuestion from '~/pages/Dairy/Survey/ShowSurvey/ShowQuestion';
import FarmerSurvey from '~/pages/Farmer/Survey'
import PreviewSurvey from '~/pages/Dairy/Survey/PreviewSurvey';
import RequestEntries from '~/pages/Farmer/Survey/RequestEntries';
import MilkDelivery from '~/pages/Dairy/MilkMoney/MilkDelivery';
import MilkMoney from '~/pages/Dairy/Settings/MilkMoney';
import ImportTours from '~/pages/Dairy/MilkMoney/MilkDelivery/ImportTours';
import ShowTours from '~/pages/Dairy/MilkMoney/MilkDelivery/ShowTours';
import MilkDeliveryFarmer from '~/pages/Farmer/MilkDelivery'
import MilkSamplesFarmer from '~/pages/Farmer/MilkSamples'
import MilkSamples from '~/pages/Dairy/MilkMoney/MilkSamples';
import ShowSamples from '~/pages/Dairy/MilkMoney/MilkSamples/ShowSamples';
import MilkFTPLogs from '~/pages/Dairy/MilkMoney/Ftplogs';
import ResultsSurvey from '~/pages/Dairy/Survey/ResultsSurvey';
import AnswersPreview from '~/pages/Dairy/Survey/ResultsSurvey/AnwsersPreview';
import RecreateSurvey from '~/pages/Dairy/Survey/RecreateSurvey';
import QuestionStatistics from '~/pages/Dairy/Survey/ShowSurvey/QuestionStatistics';
import AddQuestions from '~/pages/Dairy/Survey/ShowSurvey/AddQuestions';
import VAT from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/VAT';
import StoneX from '~/pages/Dairy/FutureContracts/StoneX';
import MilkTypes from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/MilkTypes';
import TourPlanning from '~/pages/Dairy/MilkMoney/TourPlanning';
import FormsOfHusbandry from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/FormsOfHusbandry';
import NotificationsPage from '~/pages/Farmer/NotificationsPage';
import ShopManagment from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/ShopManagment';
import CreateEditArticle from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/ShopManagment/CreateEditArticle';
import ArticleBookings from '~/pages/Dairy/Reporting/ArticleBookings';
import Invoice from '~/pages/Dairy/MilkMoney/Invoice';
import DistrictDelivery from '~/pages/Dairy/Reporting/DistrictDelivery';
import DetailsDelivery from '~/pages/Dairy/Reporting/DistrictDelivery/DetailsDelivery';
import EditInvoice from '~/pages/Dairy/MilkMoney/Invoice/EditInvoice';
import FatAndProteinPrice from '~/pages/Dairy/FatAndProteinPrice';
import CreateEditFatAndProteinPrice from '~/pages/Dairy/FatAndProteinPrice/CreateEditFatAndProteinPrice';
import ShowFatAndProteinPrice from '~/pages/Dairy/FatAndProteinPrice/ShowFatAndProteinPrice';
import ResultsFatAndProteinPrice from '~/pages/Dairy/FatAndProteinPrice/ResultsFatAndProteinPrice';
import FarmerFatAndProteinPrice from '~/pages/Farmer/FatAndProteinPrice';
import FatAndProteinOfferAmount from '~/pages/Farmer/FatAndProteinPrice/OfferAmount'
import FarmerShowFatAndProteinPrice from '~/pages/Farmer/FatAndProteinPrice/ShowFatAndProteinPrice';
import OffersPreviewFatAndProteinPrice from '~/pages/Dairy/FatAndProteinPrice/OffersPreviewFatAndProteinPrice';
import FarmerResultsFatAndProteinPrice from '~/pages/Farmer/FatAndProteinPrice/ResultsFatAndProteinPrice';
import { ADMIN_ROLE_SLUG, CO2_LFL_SLUG, FARMER_ROLE_SLUG } from '~/Constants';
import StockExchange from '~/pages/Dairy/StockExchange';
import CreateEditStockExchange from '~/pages/Dairy/StockExchange/CreateEditStocExchange';
import ShowStockExchange from '~/pages/Dairy/StockExchange/ShowStockExchange';
import ResultsStockExchange from '~/pages/Dairy/StockExchange/Results';
import OffersPreviewStockExchange from '~/pages/Dairy/StockExchange/OffersPreviewStockExchange';
import StockExchangeFarmer from '~/pages/Farmer/StockExchange'
import OfferAmountStockFarmer from '~/pages/Farmer/StockExchange/OfferAmount';
import FarmerStockShow from '~/pages/Farmer/StockExchange/Show'
import FarmerStockResults from '~/pages/Farmer/StockExchange/Results'
import Co2Climate from '~/pages/Dairy/Co2Climate';
import Co2ClimateFarmer from '~/pages/Farmer/Co2Climate';
import CreateEditCo2Climate from '~/pages/Dairy/Co2Climate/CreateEditCo2Climate';
import AnswerCO2Climate from '~/pages/Farmer/Co2Climate/AnswerCO2Climate';
import ShowCO2Climate from '~/pages/Dairy/Co2Climate/ShowCO2Climate';
import ResultsCO2Climate from '~/pages/Dairy/Co2Climate/ResultsCO2Climate';
import { getRoute } from '~/utils/helpers';
import Co2Settings from '~/pages/Dairy/Settings/Co2';
import IndividualFilters from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/IndividualFilters';
import Co2ClimateReport from '~/pages/Dairy/Reporting/CoClimate';
import FarmMilkDelivery from '~/pages/Farmer/MyFarm/MilkDelivery';
import FarmMilkMoney from '~/pages/Farmer/MyFarm/MilkMoney';
import FarmMilkQuality from '~/pages/Farmer/MyFarm/MilkQuality';
import ClimateCheck from '~/pages/Dairy/ClimateCheck';
import CreateEditClimaCh from '~/pages/Dairy/ClimateCheck/CreateEditClimaCh';
import ShowClimaCh from '~/pages/Dairy/ClimateCheck/ShowClimaCh/ShowClimaCh';
import FarmerClimateCheck from '~/pages/Farmer/ClimateCheck/index'
import AnswerClimateCheck from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck';
import CoClimateRepoFarm from '~/pages/Farmer/Reporting/CoClimate'
import ResultsClimateCheck from '~/pages/Dairy/ClimateCheck/ResultsClimateCheck';
import KPM from '~/pages/Dairy/Settings/KPM';
import StoneXBle from '~/pages/Dairy/DairyFactory/StoneXBle';
import CreateEditStoneXBle from '~/pages/Dairy/DairyFactory/StoneXBle/CreateEditStoneXBle';
import CoolFarm from '~/pages/Dairy/CoolFarm';
import CreateEditCoolFarm from '~/pages/Dairy/CoolFarm/CreateEditCoolFarm';
import PartPayment from '~/pages/Dairy/MilkMoney/PartPayment';
import AdditionalPayment from '~/pages/Dairy/MilkMoney/AdditionalPayment';
import Managers from '~/pages/Dairy/DairyFactory/Managers';
import CreateManager from '~/pages/Dairy/DairyFactory/Managers/CreateManager';
import ShowManager from '~/pages/Dairy/DairyFactory/Managers/ShowManager';
import Associations from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/Associations';
import MembershipStatuses from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/MembershipStatuses';
import Certifications from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/Certifications';
import CollectionCycle from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/CollectionCycle';
import ContractType from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/ContractType';
import BillingGroups from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/BillingGroups';
import TransportTariffs from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/TransportTariffs';
import TransportationArea from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/TransportationArea';
import ProductionZone from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/ProductionZone';
import OperatingForm from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/OperatingForm';
import RestrictionPeriods from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/RestrictionPeriods';
import CollectionPoints from '~/pages/Dairy/DairyFactory/CollectionPoints';
import CreateEditCollectionPoint from '~/pages/Dairy/DairyFactory/CollectionPoints/CreateEditCollectionPoint';
import CollectionSites from '~/pages/Dairy/DairyFactory/CollectionSites';
import CreateEditCollectionSites from '~/pages/Dairy/DairyFactory/CollectionSites/CreateEditCollectionSites';
import CollectionTypes from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/CollectionTypes';
import SwissFarmers from '~/pages/Dairy/DairyFactory/SwissFarmers';
import KlimaProgram from '~/pages/Dairy/Settings/KlimaProgram';
import FeedPurchases from '~/pages/Dairy/ClimaProgram/FeedPurchases';
import Registration from '~/pages/Dairy/ClimaProgram/Registration';
import CreateEditSwissFarmers from '~/pages/Dairy/DairyFactory/SwissFarmers/CreateEditFarmers'
import EditFeedPurchases from '~/pages/Dairy/ClimaProgram/FeedPurchases/EditFeedPurchases';
import ManagerUsers from '~/pages/Dairy/DairyFactory/ManagerUsers';
import CreateManagerUser from '~/pages/Dairy/DairyFactory/ManagerUsers/CreateManagerUser';
import GassEmissions from '~/pages/Dairy/Reporting/GassEmissions';
import PurchasedAmount from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/PurchasedAmounts';
import Segmentation from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/Segmentation';
import CurrentMilkPrice from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/CurrentMilkPrice';
import ClimaCheckReporting from '~/pages/Dairy/Reporting/ClimaCheck';
import SwissShowFarmers from '~/pages/Dairy/DairyFactory/SwissFarmers/ShowFarmer'
import SwissMilkDelivery from '~/pages/Dairy/MilkMoney/SwissMilkDelivery';
import SwissMilkSamples from '~/pages/Dairy/MilkMoney/SwissMilkSamples';
import SwissAvgFarmerValues from '~/pages/Dairy/MilkMoney/SwissAvgFarmerValues';
import EditRegistration from '~/pages/Dairy/ClimaProgram/Registration/EditRegistration';
import Co2Exports from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/Co2Exports'
import ClimaExports from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/ClimaExports';
import ChangeRequest from '~/pages/Dairy/DairyFactory/ChangeRequests';
import ChangeRequestReview from '~/pages/Dairy/DairyFactory/ChangeRequests/ChangeRequestReview';

const RoutesComponent: React.FC = () => {
  const { systemData } = useAuth();
  const operativeUsersCanSeeFarmersInfo = systemData?.operativeUsersCanSeeFarmersInfo || 0
  const farmerLogged = systemData?.logged?.roleSlug === FARMER_ROLE_SLUG
  const adminLogged = systemData?.logged?.roleSlug === ADMIN_ROLE_SLUG
  const hasCO2Module = systemData?.modules.find(module => module.slug === CO2_LFL_SLUG)
  const path = hasCO2Module && systemData?.logged?.roleSlug === FARMER_ROLE_SLUG ? RouteTypes.CO2_CLIMATE :
    getRoute(systemData?.logged?.roleSlug || '', operativeUsersCanSeeFarmersInfo)
  const isSwissDairy = Boolean(systemData?.chEnv)

  return <Routes>
    <Route path={RouteTypes.SET_PASSWORD_LOGGED} element={localStorage.getItem('token') ? <SetPassword /> : <PasswordForm />} />
    <Route path={RouteTypes.RESET_PASSWORD_LOGGED} element={localStorage.getItem('token') ? <SetPassword resetPassword /> : <PasswordForm resetPassword />} />
    <Route path={RouteTypes.FORCE_UPDATE_PASSWORD} element={<ForceChangePassForm />} />
    <Route key={'private'} path={RouteTypes.BASE} element={<PrivateRoute />}>
      <Route path={RouteTypes.SET_PASSWORD_LOGGED} element={localStorage.getItem('token') ? <SetPassword /> : <PasswordForm />} />
      <Route path={RouteTypes.RESET_PASSWORD_LOGGED} element={localStorage.getItem('token') ? <SetPassword resetPassword /> : <PasswordForm resetPassword />} />
      <Route key={RouteTypes.BASE} path={RouteTypes.BASE} element={<InnerContent />}>
        <Route
          key={RouteTypes.PROFILE_SETTINGS}
          path={RouteTypes.PROFILE_SETTINGS}
          element={<ProfileSettings />}
        />
        {/* Dashboard */}
        <Route
          path={RouteTypes.BASE}
          element={<Navigate replace to={farmerLogged ? path : RouteTypes.DAIRY_FACTORY_PROFILE_USERS} />}
        ></Route>
        <Route
          key={RouteTypes.DASHBOARD}
          path={RouteTypes.DASHBOARD}
          element={farmerLogged ? <DashboardFarmer /> : <Dashboard />}
        />

        {/* Profile */}
        <Route path={RouteTypes.PROFILE} element={<Profile />} />

        {/* Managers */}
        <Route path={RouteTypes.DAIRY_FACTORY_MANAGERS} element={<Managers />} />
        <Route path={RouteTypes.DAIRY_FACTORY_MANAGERS_CREATE} element={<CreateManager />} />
        <Route path={RouteTypes.DAIRY_FACTORY_MANAGERS_SHOW} element={<ShowManager />} />

        {/* Collection points */}
        <Route path={RouteTypes.DAIRY_FACTORY_COLLECTION_POINTS} element={<CollectionPoints />} />
        <Route path={RouteTypes.DAIRY_FACTORY_COLLECTION_POINTS_CREATE} element={<CreateEditCollectionPoint />} />
        <Route path={RouteTypes.DAIRY_FACTORY_COLLECTION_POINTS_EDIT} element={<CreateEditCollectionPoint />} />

        {/* Collection sites */}
        <Route path={RouteTypes.DAIRY_FACTORY_COLLECTION_SITE} element={<CollectionSites />} />
        <Route path={RouteTypes.DAIRY_FACTORY_COLLECTION_SITE_CREATE} element={<CreateEditCollectionSites />} />
        <Route path={RouteTypes.DAIRY_FACTORY_COLLECTION_SITE_EDIT} element={<CreateEditCollectionSites />} />

        {/* Farmer Profile */}
        <Route path={RouteTypes.FARMER_PROFILE} element={farmerLogged ? <FarmerProfile /> : <NotFoundPage />} />

        {/* DairyFactory */}
        <Route key={RouteTypes.DAIRY_FACTORY} path={RouteTypes.DAIRY_FACTORY} element={<DairyFactory />}>

          <Route index element={<DairyFactoryProfile />} />

          {/* Users */}
          <Route
            key={RouteTypes.DAIRY_FACTORY_PROFILE}
            path={RouteTypes.DAIRY_FACTORY_PROFILE}
            element={<DairyFactoryProfile />}
          >
            <Route index element={<Navigate replace to={RouteTypes.DAIRY_FACTORY_PROFILE_USERS} />} />
            {/* Milk types */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_MILK_TYPES}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_MILK_TYPES}
              element={<MilkTypes />}
            ></Route>

            {/* Locations */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_LOCATIONS}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_LOCATIONS}
              element={<DairyFactoryProfileLocations />}
            ></Route>

            {/* Individual filters */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS + '/*'}
              element={<IndividualFilters />}
            ></Route>

            {/* Banks */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_BANKS}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_BANKS}
              element={<DairyFactoryProfileBanks />}
            >
              <Route
                key={RouteTypes.DAIRY_FACTORY_PROFILE_BANKS_CREATE}
                path={RouteTypes.DAIRY_FACTORY_PROFILE_BANKS_CREATE}
                element={<CreateEditBanks handleHiddenDrawer={null} isVisible={false} />}
              ></Route>
              <Route
                key={RouteTypes.DAIRY_FACTORY_PROFILE_BANKS_EDIT}
                path={RouteTypes.DAIRY_FACTORY_PROFILE_BANKS_EDIT}
                element={<CreateEditBanks handleHiddenDrawer={null} isVisible={false} />}
              ></Route>
            </Route>

            {/* Vat */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_VAT}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_VAT}
              element={<VAT />}
            ></Route>

            {/* Co2 export */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_CO2_EXPORT}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_CO2_EXPORT}
              element={<Co2Exports />}
            ></Route>

            {/* Clima export */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_CLIMA_EXPORT}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_CLIMA_EXPORT}
              element={<ClimaExports />}
            ></Route>

            {/* Farmer Groups */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_FARMER_GROUPS}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_FARMER_GROUPS}
              element={<FarmerGroups />}
            />

            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_FARMER_GROUPS_SHOW}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_FARMER_GROUPS_SHOW}
              element={<ShowFarmerGroup />}
            />

            {/* Milk payment */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_MILK_PAYMENT}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_MILK_PAYMENT}
              element={<MilkPayment />}
            />

            {/* Price calculator*/}
            <Route
              path={RouteTypes.DAIRY_FACTORY_PROFILE_BASE_PRICE}
              element={<PriceCalculator />}
            />

            {/* Shop managment */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_SHOP} element={<ShopManagment />} />
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_SHOP_CREATE} element={<CreateEditArticle />} />
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_SHOP_EDIT} element={<CreateEditArticle />} />

            {/* Associations */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_ASSOCIATIONS} element={<Associations />} />

            {/* Membership statuses */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_MEMBERSHIP_STATUSES} element={<MembershipStatuses />} />

            {/* Certifications */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_CERTIFICATIONS} element={<Certifications />} />

            {/* Collection Cycles */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_COLLECTION_CYCLES} element={<CollectionCycle />} />

            {/* Contract Types */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_CONTRACT_TYPES} element={<ContractType />} />

            {/* Billing Groups */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_BILLING_GROUPS} element={<BillingGroups />} />

            {/* Transport Tariffs */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_TRANSPORT_TARIFFS} element={<TransportTariffs />} />

            {/* Colleciton Types */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_COLLECTION_TYPES} element={<CollectionTypes />} />

            {/* Transportation Areas */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_TRANSPORTATION_AREAS} element={<TransportationArea />} />

            {/* Production Zones */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_PRODUCTION_ZONES} element={<ProductionZone />} />

            {/* Operating Forms */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_OPERATING_FORMS} element={<OperatingForm />} />

            {/* Restriction Periods */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_RESTRICTION_PERIODS} element={<RestrictionPeriods />} />

            {/* Purchased Amounts */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_PURCHASED_AMOUNTS} element={<PurchasedAmount />} />

            {/* Segmentation */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_SEGMENTATION} element={<Segmentation />} />

            {/* Current Milk Price */}
            <Route path={RouteTypes.DAIRY_FACTORY_PROFILE_MILK_PRICES} element={<CurrentMilkPrice />} />

            {/* Users */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_USERS}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_USERS}
              element={<DairyFactoryProfileUsers />}
            />

            {/* Forms of husbandry */}
            <Route
              key={RouteTypes.DAIRY_FACTORY_PROFILE_HUSBANDRY}
              path={RouteTypes.DAIRY_FACTORY_PROFILE_HUSBANDRY}
              element={<FormsOfHusbandry />}
            />

          </Route>

          {/* Farmers */}
          <Route path={RouteTypes.DAIRY_FACTORY_FARMERS} element={isSwissDairy ? <SwissFarmers /> : <Farmers />} />
          <Route path={RouteTypes.DAIRY_FACTORY_FARMERS_CREATE} element={isSwissDairy ? <CreateEditSwissFarmers /> : <CreateEditFarmers />} />
          <Route path={RouteTypes.DAIRY_FACTORY_FARMERS_EDIT} element={isSwissDairy ? <CreateEditSwissFarmers /> : <CreateEditFarmers />} />
          <Route path={RouteTypes.DAIRY_FACTORY_FARMERS_SHOW} element={isSwissDairy ? <SwissShowFarmers /> : <ShowFarmer />} />
          <Route path={RouteTypes.DAIRY_FACTORY_FARMERS_MGA_ATTACHMENTS} element={<MgaAttachment />} />
          <Route path={RouteTypes.DAIRY_FACTORY_FARMERS_MGA_ATTACHMENT_CREATE} element={<CreateMgaAttachment />} />

          {/* Farmer Users */}
          <Route path={RouteTypes.DAIRY_FACTORY_FARMER_USERS} element={<FarmerUsers />} />
          <Route path={RouteTypes.DAIRY_FACTORY_FARMER_USERS_CREATE} element={<CreateFarmerUser />} />

          {/* Manager Users */}
          <Route path={RouteTypes.DAIRY_FACTORY_MANAGER_USERS} element={<ManagerUsers />} />
          <Route path={RouteTypes.MANAGER_USER_EDIT} element={<CreateEditUser />} />
          <Route path={RouteTypes.DAIRY_FACTORY_MANAGER_USERS_CREATE} element={<CreateManagerUser />} />

          {/* Activity Logs */}
          <Route path={RouteTypes.DAIRY_FACTORY_PRICE_ACTIVITY_LOGS} element={<ActivityLogs />} />
          <Route path={RouteTypes.DAIRY_FACTORY_PRICE_ACTIVITY_LOGS_HISTORY} element={<History />} />

          {/* Change Requests */}
          <Route path={RouteTypes.DAIRY_FACTORY_CHANGE_REQUESTS} element={<ChangeRequest />} />
          <Route path={RouteTypes.DAIRY_FACTORY_CHANGE_REQUEST_REVIEW} element={<ChangeRequestReview />} />

          {/* Stone X Ble */}
          <Route path={RouteTypes.DAIRY_FACTORY_STONE_X_BLE} element={<StoneXBle />} />
          <Route path={RouteTypes.DAIRY_FACTORY_STONE_X_BLE_CREATE} element={<CreateEditStoneXBle />} />
          <Route path={RouteTypes.DAIRY_FACTORY_STONE_X_BLE_EDIT} element={<CreateEditStoneXBle />} />
        </Route>

        {/* Reporting */}
        <Route key={RouteTypes.REPORTING_TRADING_ACTIVITIES} path={RouteTypes.REPORTING_TRADING_ACTIVITIES} element={farmerLogged ? <ReportTradingActivities /> : <DairyTradingActivities />} />
        <Route path={RouteTypes.REPORTING_PRICE} element={farmerLogged ? <ReportFixedPrice /> : <DairyFixedPrice />} />
        <Route path={RouteTypes.REPORTING_ARTICLE_BOOKINGS} element={farmerLogged ? <NotFoundPage /> : <ArticleBookings />} />
        <Route path={RouteTypes.REPORTING_DISTRICT_DELIVERY} element={farmerLogged ? <NotFoundPage /> : <DistrictDelivery />} />
        <Route path={RouteTypes.REPORTING_DISTRICT_DELIVERY_DETAILS} element={farmerLogged ? <NotFoundPage /> : <DetailsDelivery />} />
        <Route path={RouteTypes.REPORTING_CO2} element={farmerLogged ? <CoClimateRepoFarm /> : <Co2ClimateReport />} />
        <Route path={RouteTypes.REPORTING_CO2_GASS_EMISSIONS} element={<GassEmissions />} />
        <Route path={RouteTypes.REPORTING_CLIMA_CHECK} element={<ClimaCheckReporting />} />

        {/* Milk money */}
        <Route path={RouteTypes.MILK_MONEY_TOUR_PLANNING} element={<TourPlanning />} />
        <Route path={RouteTypes.MILK_SAMPLES} element={farmerLogged ? <MilkSamplesFarmer /> : <NotFoundPage />} />
        <Route path={RouteTypes.MILK_MONEY_DELIVERY} element={farmerLogged ? <MilkDeliveryFarmer /> : <MilkDelivery />} />
        <Route path={RouteTypes.MILK_MONEY_INVOICE} element={<Invoice />} />
        <Route path={RouteTypes.MILK_MONEY_PART_PAYMENT} element={<PartPayment />} />
        <Route path={RouteTypes.MILK_MONEY_ADDITIONAL_PAYMENT} element={<AdditionalPayment />} />
        <Route path={RouteTypes.MILK_MONEY_INVOICE_EDIT} element={<EditInvoice />} />
        <Route path={RouteTypes.MILK_MONEY_TOURS_IMPORT} element={<ImportTours />} />
        <Route path={RouteTypes.MILK_MONEY_TOURS_SHOW} element={<ShowTours />} />
        <Route path={RouteTypes.MILK_MONEY_SAMPLES_PSEUDOM} element={<MilkSamples />} />
        <Route path={RouteTypes.MILK_MONEY_SAMPLES_INDIVIDUAL} element={<MilkSamples />} />
        <Route path={RouteTypes.MILK_MONEY_SAMPLES_INDIVIDUAL_VALUES} element={<SwissMilkSamples />} />
        <Route path={RouteTypes.MILK_MONEY_SAMPLES_AVERAGE_VALUES} element={<SwissAvgFarmerValues />} />
        <Route path={RouteTypes.MILK_MONEY_SAMPLES_FARMER} element={<MilkSamples />} />
        <Route path={RouteTypes.MILK_MONEY_SAMPLES_DAIRY} element={<MilkSamples />} />
        <Route path={RouteTypes.MILK_MONEY_SWISS_DELIVERY} element={<SwissMilkDelivery />} />
        <Route path={RouteTypes.MILK_MONEY_SAMPLES_SHOW} element={<ShowSamples />} />
        <Route path={RouteTypes.MILK_MONEY_FTP_LOGS} element={adminLogged ? < MilkFTPLogs /> : <NotFoundPage />} />

        {/* Notifications */}
        <Route path={RouteTypes.NOTIFICATIONS} element={<NotificationsPage />} />

        {/* Settings */}
        <Route path={RouteTypes.SETTINGS} element={<Settings />} />
        <Route path={RouteTypes.SETTINGS_CLOUD_STORAGE} element={<SettingsCloudStorage />} />
        <Route path={RouteTypes.SETTINGS_TRADING_SLOT} element={<TradingSlot />} />
        <Route path={RouteTypes.SETTINGS_FAQ} element={<FaqBuilder />} />
        <Route path={RouteTypes.SEETINGS_MESSAGE} element={<Messaging />} />
        <Route path={RouteTypes.SETTINGS_SECURITY} element={<Security />} />
        <Route path={RouteTypes.SETTINGS_LOGIN_POPUP} element={<LoginPopup />} />
        <Route path={RouteTypes.SETTINGS_LOGIN_POPUP_CREATE} element={<CreateEditLoginPopup />} />
        <Route path={RouteTypes.SETTINGS_LOGIN_POPUP_EDIT} element={<CreateEditLoginPopup />} />
        <Route path={RouteTypes.SETTINGS_GENERAL} element={<General />} />
        <Route path={RouteTypes.SETTINGS_FTP} element={<FTP />} />
        <Route path={RouteTypes.SETTINGS_FTP_LOGS} element={<FTPLogs />} />
        <Route path={RouteTypes.SETTINGS_MILK_MONEY} element={<MilkMoney />} />
        <Route path={RouteTypes.SETTINGS_CO2_CLIMATE} element={<Co2Settings />} />
        <Route path={RouteTypes.SETTINGS_CLIMA_CHECK} element={<KPM />} />
        <Route path={RouteTypes.SETTINGS_KLIMA_PROGRAM} element={<KlimaProgram />} />

        {/* Clima Program */}
        <Route path={RouteTypes.CLIMA_PROGRAM_REGISTRATIONS} element={<Registration />} />
        <Route path={RouteTypes.CLIMA_PROGRAM_REGISTRATION_EDIT} element={<EditRegistration />} />
        <Route path={RouteTypes.CLIMA_PROGRAM_REGISTRATION_CREATE} element={<EditRegistration />} />
        <Route path={RouteTypes.CLIMA_PROGRAM_FEED_PURCHASES} element={<FeedPurchases />} />
        <Route path={RouteTypes.CLIMA_PROGRAM_FEED_PURCHASES_EDIT} element={<EditFeedPurchases />} />
        <Route path={RouteTypes.CLIMA_PROGRAM_FEED_PURCHASES_CREATE} element={<EditFeedPurchases />} />

        {/* Users */}
        <Route path={RouteTypes.USERS_EDIT} element={<CreateEditUser />} />
        <Route path={RouteTypes.FARMER_USERS_EDIT} element={<CreateEditUser />} />
        <Route path={RouteTypes.USERS_SHOW} element={<ShowUser />} />

        {/* My farm */}
        <Route path={RouteTypes.FARM_MILK_DELIVERY} element={farmerLogged ? <FarmMilkDelivery /> : <NotFoundPage />} />
        <Route path={RouteTypes.FARM_MILK_QUALITY} element={farmerLogged ? <FarmMilkQuality /> : <NotFoundPage />} />
        <Route path={RouteTypes.FARM_MILK_MILK_MONEY} element={farmerLogged ? <FarmMilkMoney /> : <NotFoundPage />} />

        {/* Trading slot */}
        <Route path={RouteTypes.MILK_FIXED_PRICE} element={farmerLogged ? <FarmerMilkFixedPrice /> : <MilkFixedPrice />} />
        <Route key={RouteTypes.MILK_FIXED_PRICE_CREATE} path={RouteTypes.MILK_FIXED_PRICE_CREATE} element={<CreateEditMilkFixedPrice />} />
        <Route key={RouteTypes.MILK_FIXED_PRICE_EDIT} path={RouteTypes.MILK_FIXED_PRICE_EDIT} element={<CreateEditMilkFixedPrice />} />
        <Route path={RouteTypes.MILK_FIXED_PRICE_SHOW} element={farmerLogged ? <Show /> : <ShowMilkFixedPrice />} />
        <Route path={RouteTypes.MILK_FIXED_PRICE_OFFERS_PREVIEW} element={<OffersPreviewMilkFixedPrice />} />
        <Route path={RouteTypes.MILK_FIXED_PRICE_OFFER_AMOUNT} element={<OfferAmount />} />
        <Route path={RouteTypes.MILK_FIXED_PRICE_RESULTS} element={farmerLogged ? <ResultsFarmer /> : <Results />} />

        {/* New Trading slot */}
        <Route path={RouteTypes.PREFIX_TRADING_SLOT_SHOW} element={farmerLogged ? <Show /> : <NotFoundPage />} />
        <Route path={RouteTypes.PREFIX_TRADING_SLOT_RESULTS} element={farmerLogged ? <ResultsFarmer /> : <NotFoundPage />} />
        <Route path={RouteTypes.PREFIX_TRADING_SLOT_OFFER_AMOUNT} element={farmerLogged ? <OfferAmount /> : <NotFoundPage />} />

        {/* Fat and Protein slots */}
        <Route path={RouteTypes.FAT_PROTEIN_PRICE} element={farmerLogged ? <FarmerFatAndProteinPrice /> : <FatAndProteinPrice />} />
        <Route key={RouteTypes.FAT_PROTEIN_PRICE_CREATE} path={RouteTypes.FAT_PROTEIN_PRICE_CREATE} element={<CreateEditFatAndProteinPrice />} />
        <Route key={RouteTypes.FAT_PROTEIN_PRICE_EDIT} path={RouteTypes.FAT_PROTEIN_PRICE_EDIT} element={<CreateEditFatAndProteinPrice />} />
        <Route path={RouteTypes.FAT_PROTEIN_PRICE_SHOW} element={farmerLogged ? <FarmerShowFatAndProteinPrice /> : <ShowFatAndProteinPrice />} />
        <Route path={RouteTypes.FAT_PROTEIN_PRICE_RESULTS} element={farmerLogged ? <FarmerResultsFatAndProteinPrice /> : <ResultsFatAndProteinPrice />} />
        <Route path={RouteTypes.FAT_PROTEIN_PRICE_OFFER_AMOUNT} element={<FatAndProteinOfferAmount />} />
        <Route path={RouteTypes.FAT_PROTEIN_PRICE_PREVIEW} element={<OffersPreviewFatAndProteinPrice />} />

        {/* Stock exchange slots */}
        <Route path={RouteTypes.STOCK_EXCHANGE} element={farmerLogged ? <StockExchangeFarmer /> : <StockExchange />} />
        <Route key={RouteTypes.STOCK_EXCHANGE_CREATE} path={RouteTypes.STOCK_EXCHANGE_CREATE} element={<CreateEditStockExchange />} />
        <Route key={RouteTypes.STOCK_EXCHANGE_EDIT} path={RouteTypes.STOCK_EXCHANGE_EDIT} element={<CreateEditStockExchange />} />
        <Route path={RouteTypes.STOCK_EXCHANGE_SHOW} element={farmerLogged ? <FarmerStockShow /> : <ShowStockExchange />} />
        <Route path={RouteTypes.STOCK_EXCHANGE_RESULTS} element={farmerLogged ? <FarmerStockResults /> : <ResultsStockExchange />} />
        <Route path={RouteTypes.STOCK_EXCHANGE_OFFER_AMOUNT} element={farmerLogged ? <OfferAmountStockFarmer /> : <NotFoundPage />} />
        <Route path={RouteTypes.STOCK_EXCHANGE_OFFERS_PREVIEW} element={<OffersPreviewStockExchange />} />

        {/* Survey */}
        <Route path={RouteTypes.SURVEY} element={farmerLogged ? <FarmerSurvey /> : <Survey />} />
        <Route path={RouteTypes.SURVEY_CREATE} element={<CreateEditSurvey />} />
        <Route path={RouteTypes.SURVEY_EDIT} element={<CreateEditSurvey />} />
        <Route path={RouteTypes.SURVEY_SHOW} element={<ShowSurvey />} />
        <Route path={RouteTypes.SURVEY_SHOW_QUESTION_CREATE} element={<CreateEditQuestion />} />
        <Route path={RouteTypes.SURVEY_SHOW_QUESTION_EDIT} element={<CreateEditQuestion />} />
        <Route path={RouteTypes.SURVEY_SHOW_QUESTION_SHOW} element={<ShowQuestion />} />
        <Route path={RouteTypes.SURVEY_SHOW_QUESTIONS_ADD} element={<AddQuestions />} />
        <Route path={RouteTypes.SURVEY_STATISTICS} element={<QuestionStatistics />} />
        <Route path={RouteTypes.SURVEY_SHOW_QUESTION_STATISTICS} element={<QuestionStatistics />} />
        <Route path={RouteTypes.SURVEY_RECREATE} element={<RecreateSurvey />} />
        <Route path={RouteTypes.SURVEY_QUESTIONS_PREVIEW} element={<PreviewSurvey />} />
        <Route path={RouteTypes.SURVEY_SHOW_RESUTLS} element={<ResultsSurvey />} />
        <Route path={RouteTypes.SURVEY_SHOW_ANSWERS} element={<AnswersPreview />} />
        <Route path={RouteTypes.SURVEY_SHOW_RESUTLS_ANSWERS} element={<AnswersPreview />} />
        <Route path={RouteTypes.SURVEY_EDIT_ENTRIES} element={farmerLogged ? <RequestEntries edit /> : <NotFoundPage />} />
        <Route path={RouteTypes.SURVEY_REQUEST_ENTRIES} element={farmerLogged ? <RequestEntries /> : <NotFoundPage />} />

        {/* Faq */}
        <Route path={RouteTypes.FAQ} element={<Faq />} />
        <Route path={RouteTypes.FAQ_CREATE} element={<CreateEditFaq />} />
        <Route path={RouteTypes.FAQ_EDIT} element={<CreateEditFaq />} />

        {/* Cloud storage */}
        <Route path={RouteTypes.CLOUD_STORAGE} element={<CloudStorage />} />

        {/* Newsletter */}
        <Route path={RouteTypes.NEWSLETTER} element={farmerLogged ? <NewsletterFarmer /> : <Newsletter />} />
        <Route key={RouteTypes.NEWSLETTER_CREATE} path={RouteTypes.NEWSLETTER_CREATE} element={<CreateEditNewsletter />} />
        <Route key={RouteTypes.NEWSLETTER_EDIT} path={RouteTypes.NEWSLETTER_EDIT} element={<CreateEditNewsletter />} />
        <Route key={RouteTypes.NEWSLETTER_SHOW} path={RouteTypes.NEWSLETTER_SHOW} element={farmerLogged ? <NewsLetterPreviewFarmer /> : <ShowNewsletterDairy />} />

        {/* Future Contracts */}
        <Route path={RouteTypes.FUTURE_CONTRACTS_STONEX} element={<StoneX />} />
        <Route path={RouteTypes.FUTURE_CONTRACTS_TYPES} element={<FutureContracts />} />
        <Route path={RouteTypes.FUTURE_CONTRACTS_TYPES_CHART} element={<FutureContractsChart />} />

        {/* CO2 Climate */}
        <Route path={RouteTypes.CO2_CLIMATE} element={farmerLogged ? <Co2ClimateFarmer /> : <Co2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_CREATE} element={<CreateEditCo2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_EDIT} element={<CreateEditCo2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_SHOW} element={<ShowCO2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_RESULTS} element={<ResultsCO2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_ANSWER} element={farmerLogged ? <AnswerCO2Climate /> : <NotFoundPage />} />
        <Route path={RouteTypes.CO2_CLIMATE_SUB_FARMER_ANSWER} element={farmerLogged ? <AnswerCO2Climate /> : <NotFoundPage />} />
        <Route path={RouteTypes.CO2_CLIMATE_EDIT_ANSWER} element={farmerLogged ? <AnswerCO2Climate /> : <NotFoundPage />} />
        <Route path={RouteTypes.CO2_CLIMATE_EDIT_SUB_FARMER_ANSWER} element={farmerLogged ? <AnswerCO2Climate /> : <NotFoundPage />} />
        <Route path={RouteTypes.CO2_CLIMATE_DRAFT_ANSWER} element={farmerLogged ? <AnswerCO2Climate /> : <NotFoundPage />} />
        <Route path={RouteTypes.CO2_CLIMATE_DRAFT_SUB_FARMER_ANSWER} element={farmerLogged ? <AnswerCO2Climate /> : <NotFoundPage />} />

        {/* CO2 Climate */}
        <Route path={RouteTypes.CLIMATE_CHECK} element={farmerLogged ? <FarmerClimateCheck /> : <ClimateCheck />} />
        <Route path={RouteTypes.CLIMATE_CHECK_CREATE} element={<CreateEditClimaCh />} />
        <Route path={RouteTypes.CLIMATE_CHECK_EDIT} element={<CreateEditClimaCh />} />
        <Route path={RouteTypes.CLIMATE_CHECK_SHOW} element={<ShowClimaCh />} />
        <Route path={RouteTypes.CLIMATE_CHECK_RESULTS} element={<ResultsClimateCheck />} />
        <Route path={RouteTypes.CLIMATE_CHECK_ANSWER} element={farmerLogged ? <AnswerClimateCheck /> : <NotFoundPage />} />
        <Route path={RouteTypes.CLIMATE_CHECK_SUB_FARMER_ANSWER} element={farmerLogged ? <AnswerClimateCheck /> : <NotFoundPage />} />
        <Route path={RouteTypes.CLIMATE_CHECK_EDIT_ANSWER} element={farmerLogged ? <AnswerClimateCheck /> : <NotFoundPage />} />
        <Route path={RouteTypes.CLIMATE_CHECK_EDIT_SUB_FARMER_ANSWER} element={farmerLogged ? <AnswerClimateCheck /> : <NotFoundPage />} />
        <Route path={RouteTypes.CLIMATE_CHECK_DRAFT_ANSWER} element={farmerLogged ? <AnswerClimateCheck /> : <NotFoundPage />} />
        <Route path={RouteTypes.CLIMATE_CHECK_DRAFT_SUB_FARMER_ANSWER} element={farmerLogged ? <AnswerClimateCheck /> : <NotFoundPage />} />

        {/* Cool Farm tool */}
        <Route path={RouteTypes.COOL_FARM} element={<CoolFarm />} />
        <Route path={RouteTypes.COOL_FARM_CREATE} element={<CreateEditCoolFarm />} />
        <Route path={RouteTypes.COOL_FARM_EDIT} element={<CreateEditCoolFarm />} />

      </Route>
    </Route>

    <Route path={RouteTypes.LOGIN} element={<PublicRoute />}>
      <Route path={RouteTypes.LOGIN} element={<AuthenticationPage />} />
    </Route>

    {/* 404 route */}
    <Route path={RouteTypes.NOT_FOUND} element={<NotFoundPage />} />
  </Routes>
}
export default RoutesComponent
